import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ClubProvider } from '../../../../providers/club/club';
import { ProfilePage } from '../../../employee/profile/profile';


@Component({
    selector: 'page-club-members-list',
    templateUrl: 'club-member-list.html',
})
export class ClubMembersListPage {

    clubId: any = 0;
    clubMembers: any = null;
    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public clubProvider: ClubProvider, public modalCtrl: ModalController) {
        this.clubId = navParams.get('clubId');
    }

    ionViewDidLoad() {
        this.clubProvider.listMembers(this.clubId).subscribe((res) => {
            if (res.success) {
                this.clubMembers = res.data;
            }
        })
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    goToProfile(userId) {
        console.log(userId)
        this.modalCtrl.create(ProfilePage, { userId: userId }).present().then(() => {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/employee/network/club-member-list/club-member-list.ts